let elements = {
  blockCheck: true,
  blockWrongColor: true,
  audio: {
    negative: 'games/page036_game0/audio/false.mp3',
    // positive: 'games/page036_game0/audio/true.mp3',
    click: 'games/page036_game0/audio/click.mp3',
  },
  image: {
    defaultColors: ['', '', '#fefefe', '', ''],
    trImage: 'games/page036_game0/img/img_t.webp',
    srcImage: 'games/page036_game0/img/img_o.png',
    srcMask: 'games/page036_game0/img/img_m.png',
    width: 1920,
    height: 1080,
    colors: {
      1: '#000000',
      2: '#ffff00',
      3: '#fffffe',
      4: '#8b5a3b',
      5: '#808080',
    },
    cssStyle: {
      position: 'absolute',
      left: '0px',
      top: '0px',
      height: '1080px',
      width: '1920px',
    },
  },
  palette: {
    colors: [
      {
        val: '#05a6e2', // blue
        waitingToBeClicked: { src: 'games/page036_game0/img/blue.png' },
        clicked: { src: 'games/page036_game0/img/blue_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '17%',
          top: '92.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#e62f26', // red
        waitingToBeClicked: { src: 'games/page036_game0/img/red.png' },
        clicked: { src: 'games/page036_game0/img/red_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '23.5%',
          top: '92.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#ffff00', // yellow
        audio: 'games/page036_game0/audio/53_fish.mp3',
        waitingToBeClicked: { src: 'games/page036_game0/img/yellow.png' },
        clicked: { src: 'games/page036_game0/img/yellow_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '30%',
          top: '92.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#4faf48', // green
        waitingToBeClicked: { src: 'games/page036_game0/img/green.png' },
        clicked: { src: 'games/page036_game0/img/green_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '36.5%',
          top: '92.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#7d4e9a', // purple
        waitingToBeClicked: { src: 'games/page036_game0/img/purple.png' },
        clicked: { src: 'games/page036_game0/img/purple_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '43%',
          top: '92.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#ff69c0', // pink
        waitingToBeClicked: { src: 'games/page036_game0/img/pink.png' },
        clicked: { src: 'games/page036_game0/img/pink_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '49.5%',
          top: '92.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#f47430', // orange
        waitingToBeClicked: { src: 'games/page036_game0/img/orange.png' },
        clicked: { src: 'games/page036_game0/img/orange_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '56%',
          top: '92.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#808080', // gray
        audio: 'games/page036_game0/audio/51_cat.mp3',
        waitingToBeClicked: { src: 'games/page036_game0/img/gray.png' },
        clicked: { src: 'games/page036_game0/img/gray_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '62.5%',
          top: '92.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#8b5a3b', // brown
        audio: 'games/page036_game0/audio/50_dog.mp3',
        waitingToBeClicked: { src: 'games/page036_game0/img/brown.png' },
        clicked: { src: 'games/page036_game0/img/brown_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '69%',
          top: '92.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#fffffe', // white
        audio: 'games/page036_game0/audio/52_mouse.mp3',
        waitingToBeClicked: { src: 'games/page036_game0/img/white.png' },
        clicked: { src: 'games/page036_game0/img/white_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '75.5%',
          top: '92.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
    ],
  },
  mbStaticAudioItemData: [
    {
      src: 'games/page036_game0/audio/12_brown.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page036_game0/img/audioOn.png', iconOff: 'games/page036_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 775,
        x: 620,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page036_game0/audio/13_grey.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page036_game0/img/audioOn.png', iconOff: 'games/page036_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 810,
        x: 360,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page036_game0/audio/white.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page036_game0/img/audioOn.png', iconOff: 'games/page036_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 380,
        x: 580,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page036_game0/audio/9_yellow.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page036_game0/img/audioOn.png', iconOff: 'games/page036_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 180,
        x: 485,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
  ],
};

export default elements;
